<template>
  <router-link
    v-bind="$attrs"
    :to="{
      name: 'LeadersEvent',
      params: {
        main_event_id: round.main_event_id,
        round: round.round,
        sub_event_id: round.sub_event_id
      }
    }"
  >
    <slot />
  </router-link>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    round: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
  a {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/Links/LinkEvent.vue